import { BrandMark } from '@pa/ui'
import { CircleAlert, Info } from 'lucide-react'
import { useEffect, useRef, type ReactNode } from 'react'

/** The centred card every A- screen sits in (UserFlows §3 is [New]: built from the mockup's tokens and cards). */
export function AuthCard({ siteName, children }: { siteName: string; children: ReactNode }) {
  return (
    <main className="auth-page">
      <div className="card card-pad auth-card">
        <div className="brand-row">
          <span className="brand-mark">
            <BrandMark />
          </span>
          <span>{siteName}</span>
        </div>
        {children}
      </div>
    </main>
  )
}

/** An info or error line at the top of an A- screen. */
export function AuthBanner({ kind = 'info', children }: { kind?: 'info' | 'error'; children: ReactNode }) {
  return (
    <div className={`auth-banner ${kind === 'error' ? 'error' : ''}`} role={kind === 'error' ? 'alert' : 'status'}>
      {kind === 'error' ? <CircleAlert aria-hidden /> : <Info aria-hidden />}
      <span>{children}</span>
    </div>
  )
}

/**
 * An A- screen's `<h1>`, focused when the screen appears (Frontend §2.4: a route change moves focus to the new
 * heading, `tabIndex={-1}`; `base.css` draws no outline on it, task 07).
 */
export function AuthTitle({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLHeadingElement>(null)
  useEffect(() => {
    ref.current?.focus()
  }, [])
  return (
    <h1 ref={ref} tabIndex={-1}>
      {children}
    </h1>
  )
}
